// src/utils/orderStatus.js

export const ORDER_STATUS = {
    CART_PENDING: "Dalam Troli",
    ORDER_CONFIRMED: "Hantar Kawasan",
    ORDER_SENT_TO_HQ: "Hantar Negeri",
    HQ_DELIVERED: "Serah Kawasan",
    ORDER_COMPLETED: "Selesai",
    BRANCH_DELIVERED: "Serah Cawangan",
    ORDER_CANCELLED: "Dibatalkan",
};


